import { render } from "./TechOpsPage.vue?vue&type=template&id=35e5f2da"
import script from "./TechOpsPage.vue?vue&type=script&lang=js"
export * from "./TechOpsPage.vue?vue&type=script&lang=js"

import "./TechOpsPage.vue?vue&type=style&index=0&id=35e5f2da&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__